import React from 'react';
import { Box, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '../contexts/ThemeContext';

const SearchInput = ({ placeholder = 'Search...', value, onChange, minWidth = 250, maxWidth = 300 }) => {
  const { primaryColor, secondaryColor, primaryTextColor, secondaryTextColor } = useTheme();

  return (
    <Box
      sx={{
        px: 1,
        py: 0.2,
        borderRadius: 1,
        height: 34,
        border: `2px solid ${primaryColor}20`,
        display: 'flex',
        alignItems: 'center',
        minWidth,
        width: '100%',
        maxWidth,
      }}
    >
      <InputBase
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        sx={{
          ml: 0.5,
          fontSize: 15,
          fontFamily: 'Poppins, sans-serif',
          color: '#939393',
          fontWeight: 400,
          width: '100%',
        }}
      />
      <SearchIcon sx={{ fontSize: 22, color: '#888', mr: 0.5 }} />
    </Box>
  );
};

export default SearchInput;
